import { useComputed } from "@preact/signals";

import { toastMessage } from "../store/appStore";

/** Toast notifier. Uses role=status + aria-live=polite so screen readers
 * announce it. Reads the global toastMessage signal from the store. */
export function Toast() {
  const msg = useComputed(() => toastMessage.value);
  if (!msg.value) return null;
  return (
    <div class="toast-notification show" role="status" aria-live="polite">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>{msg.value}</span>
    </div>
  );
}
